const Z_INDEX_KEY_ATTRIBUTE = 'data-osp-zindex-key';
const Z_INDEX_VALUE_ATTRIBUTE = 'data-osp-zindex-value';

const zIndexes: Record<string, number> = {};

const getCurrentZIndex = (key: string): number => {
  const currentValue = zIndexes[key];
  return currentValue ?? 0;
};

const setCurrentZIndex = (key: string, value: number): void => {
  zIndexes[key] = value;
};

export class IndexUtils {
  public static set(key: string, element: HTMLElement, baseZIndex: number): void {
    const nextZIndex = getCurrentZIndex(key) + baseZIndex + 1;
    setCurrentZIndex(key, nextZIndex);
    element.setAttribute(Z_INDEX_KEY_ATTRIBUTE, key);
    element.setAttribute(Z_INDEX_VALUE_ATTRIBUTE, `${nextZIndex}`);
    element.style.zIndex = `${nextZIndex}`;
  }

  public static clear(element: HTMLElement): void {
    const key = element.getAttribute(Z_INDEX_KEY_ATTRIBUTE);
    const zIndexAttribute = element.getAttribute(Z_INDEX_VALUE_ATTRIBUTE);
    const zIndex = zIndexAttribute ? Number(zIndexAttribute) : Number.NaN;
    if (key && !Number.isNaN(zIndex) && zIndex === getCurrentZIndex(key)) {
      setCurrentZIndex(key, zIndex - 1);
    }

    element.removeAttribute(Z_INDEX_KEY_ATTRIBUTE);
    element.removeAttribute(Z_INDEX_VALUE_ATTRIBUTE);
    element.style.zIndex = '';
  }
}
